import type { Instrument } from "../data/instruments";
import { useI18n } from "../i18n/LocaleContext";

interface TuningSelectorProps {
  instrument: Instrument;
  value: string;
  onChange: (tuningId: string) => void;
}

export function TuningSelector({ instrument, value, onChange }: TuningSelectorProps) {
  const { t } = useI18n();

  return (
    <label className="control-field">
      <span>{t.controls.tuning}</span>
      <select
        aria-label="Select tuning"
        data-testid="tuning-select"
        value={value}
        onChange={(event) => onChange(event.currentTarget.value)}
      >
        {instrument.tunings.map((tuning) => (
          <option key={tuning.id} value={tuning.id}>
            {tuning.name}
          </option>
        ))}
      </select>
    </label>
  );
}
